<template>
	<div>
		<div class="ticket-banner">
			<div class="banner-a"></div>
		</div>
	    <AutoComplete @search="search"></AutoComplete>
        <div class="hot-product-a">
            <div class="rule">
                <div class="hot-title"><i class="iconfont icon-f-57"></i>热销目的地</div>
                <ul class="hot-nav">
                    <li :class="MyCity=='北京'?'nav-item active':'nav-item'" @click="initData('北京','id001')">北京</li>
                    <li :class="MyCity=='上海'?'nav-item active':'nav-item'" @click="initData('上海','id002')">上海</li>
                    <li :class="MyCity=='广州'?'nav-item active':'nav-item'" @click="initData('广州','id003')">广州</li>
                    <li :class="MyCity=='深圳'?'nav-item active':'nav-item'" @click="initData('深圳','id004')">深圳</li>
                    <li :class="MyCity=='成都'?'nav-item active':'nav-item'" @click="initData('成都','id005')">成都</li>
                    <li :class="MyCity=='武汉'?'nav-item active':'nav-item'" @click="initData('武汉','id006')">武汉</li>
                    <li :class="MyCity=='重庆'?'nav-item active':'nav-item'" @click="initData('重庆','id007')">重庆</li>
                    <li :class="MyCity=='珠海'?'nav-item active':'nav-item'" @click="initData('珠海','id008')">珠海</li>
                </ul>
                <div class="table-loading" v-if="isLoading">
                    <Loading :isLoading="isLoading"></Loading>
                </div>
                <div class="hot-box" v-else>
                    <div class="page-btn last-btn"><i class="iconfont icon-back"></i></div>
                    <ul class="hot-list" v-if="list[MyIndex]&&list[MyIndex].length>0" >
                        <li class="list-item" v-for="item in list[MyIndex]" @click="toDetails(item)">
                            <div class="hot-img">
                            	<img :src="item.Pic|replaceImgSrc(4)" alt="" />
                            </div>
                            <div class="hot-content">
                                <p class="hot-text">{{item.DistrictName?item.DistrictName+' | ':''}}  {{item.ScenicName}}</p>
                                <div class="hot-price" v-if="item.LowestPrice">
                                    ¥<span>{{item.LowestPrice}}</span>起
                                </div>
                                <div class="buy">抢购</div>
                            </div>
                        </li>
                    </ul>
                    <div class="textCenter" v-else>{{MyCity}}暂无可售门票</div>
                    <div class="page-btn next-btn"><i class="iconfont icon-more"></i></div>
                </div>

            </div>
        </div>
      
</div>
</template>
<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import AutoComplete from './autoComplete/autoComplete.vue'//自动完成
	export default {
        components: {
            Loading,
            AutoComplete
        },
		data () {
			return {
                Str:'',
                MyCity:'香港',
                MyIndex:'id001',
                Radius:'',
                MyLat:'',
                MyLon:'',
                list:{},
                isLoading:false
			}
		},
		methods: {
            toDetails (item) {
                window.open( '#/ticketDetails?id='+item.ScenicId+'&Str='+this.Str, '_blank');

            },
          
            search (str) {
                this.$router.push('/ticketList?Str='+str);
            },
            initData(city,index) {
             
                var that = this;
                that.MyCity=city;
                that.MyIndex=index;
                if(this.list[index])return;
               
                that.isLoading=true;
                var params = {
                    Str: that.Str,
                    TicketType: '',
                    Level: '',
                    Page: 1,
                    PageSize: 8,
                    MyCity: city||'',
                    Radius: that.Radius,
                    MyLat: that.MyLat,
                    MyLon: that.MyLon,
                }
                that.postRequest({
                    url:that.Api.getTicketList,
                    params: params
                }).then(res => {
                    that.isLoading=false;
                    if (res && res.IsSuccess) {
                        that.list[index]=res.Result;
                    } else {
                        // $state.complete();
                    }
                });
        
            }
		},
        mounted(){
            this.initData('北京','id001');
            document.title='门票预订---订房易';
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/tickets.vue